function defineAt(proto: object): void {
  const maybeAt = (proto as { at?: unknown }).at;
  if (typeof maybeAt !== "function") {
    Object.defineProperty(proto, "at", {
      configurable: true,
      enumerable: false,
      value: function at(
        this: ArrayLike<unknown> & { [index: number]: unknown },
        n: number
      ): unknown {
        if (this == null) throw new TypeError("Receiver is null or undefined");
        // ToIntegerOrInfinity
        const len = Number(this.length) >>> 0;
        let k = Math.trunc(n) || 0;
        if (k < 0) k += len;
        if (k < 0 || k >= len) return undefined;
        return this[k];
      },
      writable: true,
    });
  }
}

// Array.prototype.at
defineAt(Array.prototype);

// String.prototype.at (returns string | undefined)
const hasStringAt =
  typeof (String.prototype as unknown as { at?: unknown }).at === "function";
if (!hasStringAt) {
  Object.defineProperty(String.prototype, "at", {
    configurable: true,
    enumerable: false,
    value: function at(this: string, n: number): string | undefined {
      if (this == null) throw new TypeError("Receiver is null or undefined");
      const s = String(this);
      const len = s.length >>> 0;
      let k = Math.trunc(n) || 0;
      if (k < 0) k += len;
      if (k < 0 || k >= len) return undefined;
      return s.charAt(k);
    },
    writable: true,
  });
}

// TypedArray.prototype.at for all available TypedArrays
const globalObj: Record<string, unknown> =
  typeof globalThis !== "undefined"
    ? (globalThis as unknown as Record<string, unknown>)
    : (window as unknown as Record<string, unknown>);

const typedArrayNames = [
  "Int8Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Int16Array",
  "Uint16Array",
  "Int32Array",
  "Uint32Array",
  "Float32Array",
  "Float64Array",
  // BigInt typed arrays may not exist in older engines
  "BigInt64Array",
  "BigUint64Array",
] as const;

function isFunctionWithPrototype(
  value: unknown
): value is { prototype: object } {
  return (
    typeof value === "function" &&
    (value as { prototype?: object }).prototype != null
  );
}

for (const name of typedArrayNames) {
  const ctor = globalObj[name];
  if (isFunctionWithPrototype(ctor)) {
    defineAt(ctor.prototype);
  }
}

export {};
